import React, { useContext, useRef, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import {
  addCartByTag,
  fetchOrderStock,
  fetchReadyStock,
  searchByTag,
} from "../APICalls";
import Lottie from "lottie-react";
import animData from "../animations/add-cart2.json";
import toast from "react-hot-toast";
import { CartContext } from "../components/CartContext";
import { ProductsListContext } from "../context/ProductsListsContext";
import useMedia from "use-media";

// import

function ProductTags({ setDisplayData, fetchCartCount, fetchCartItems }) {
  const [itemTag, setItemTag] = useState('');
  const [playAnim, setPlayAnim] = useState(false);

  const lottieRef = useRef();
  const { cartItems, setCartItems } = useContext(CartContext);

  const [fetchedData, setFetchedData] = useState([]);

  const handleTagSearch = (e) => {
    // console.log(e.target.value)
    setItemTag(e.target.value);
    searchByTag(e.target.value).then((data) => {
      // console.log(data.results)
      if (data?.results) {
        setFetchedData(data.results);
        setDisplayData(data.results);
      }
    });
  };

  const handleAddCartByTag = () => {
    if (!itemTag) {
      toast("Enter Item Tag", {
        icon: "⚠️",
      });
      return;
    }
    if (!fetchedData || fetchedData.length < 0) {
      toast("No Items Found From Tag", {
        icon: "⚠️",
      });
      return;
    }
   

    addCartByTag({
      item_tag: itemTag,
    }).then((data) => {
      console.log(data)
      if (data?.message) {
        setPlayAnim(true);
        lottieRef.current?.play();
        toast.success("Successfully Added To Cart");
        fetchCartCount();
        const newCart = [...cartItems, itemTag];
        setCartItems(newCart);
      } else {
        toast.error('Enter Valid Item Tag');

      }
    });

    setItemTag("");

    setTimeout(() => {
      //   setPlayAnim(false);
      lottieRef.current?.stop();
    }, 1800);
  };

  const handleStockFilter = async (i) => {
    setselectedStockFilter(i);
    if (i==selectedStockFilter) {
      return;
    }
    // if (i == 0) {
    //   const data1 = await fetchOrderStock();
    //   const data2 = await fetchReadyStock();
    //   setDisplayData([
    //     ...(data1?.results || []),
    //     ...(data2?.results || [])
    //   ]);
      
    // } else 
    if (i == 0) {
      const data = await fetchOrderStock();
      setDisplayData(data?.results);
    } else {
      const data = await fetchReadyStock();
      setDisplayData(data?.results);
      
    }
  };

  // const stockFilters = ["All", "Order Stock", "Ready Stock"];
  // const [selectedStockFilter, setselectedStockFilter] = useState(2);

  // const [first, setfirst] = useState(second)

  const { setselectedStockFilter, selectedStockFilter, stockFilters,   } = useContext(ProductsListContext);

    const isMDDevice = useMedia('(min-width:992px)')

  return (
    <div className="w-100  d-flex align-items-center ">
      <div className="d-flex gap-1 align-items-center ml-5 " style={{marginLeft: isMDDevice ?'30px': '5px'}}>
        {stockFilters?.length > 0 &&
          stockFilters.map((item, i) => (
            <p
              key={i}
              
              className="p-1 px-sm-2 p-md-2 px-md-3 border rounded-2 fs-10 rounded-md-4 mb-0 "
              style={{
                fontSize: isMDDevice? '16px':'12px' ,
                background:
                  selectedStockFilter == i
                    ? "rgb(57, 109, 114)"
                    : "transparent",
                color: selectedStockFilter == i ? "white" : "black",
                cursor:'pointer',
                transition: "all 0.2s ease-in",
              }}
              onClick={() => handleStockFilter(i)}
            >
              {" "}
              {item}{" "}
            </p>
          ))}
      </div>

      <div className="position-relative w-25   " style={{ marginLeft: "auto",minWidth:isMDDevice ? '180px': '150px', maxWidth:   '250px' , marginRight:'15px' }}>
        <div className="tag-search-btn d-none ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="30"
            viewBox="0 0 40 40"
          >
            <defs>
              <mask id="ipTSearch0">
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinejoin="round"
                  strokeWidth="4"
                >
                  <path
                    fill="#555555"
                    d="M21 38c9.389 0 17-7.611 17-17S30.389 4 21 4S4 11.611 4 21s7.611 17 17 17Z"
                  />
                  <path
                    strokeLinecap="round"
                    d="M26.657 14.343A7.98 7.98 0 0 0 21 12a7.98 7.98 0 0 0-5.657 2.343m17.879 18.879l8.485 8.485"
                  />
                </g>
              </mask>
            </defs>
            <path
              fill="currentColor"
              d="M0 0h48v48H0z"
              mask="url(#ipTSearch0)"
            />
          </svg>
          {/* <Search /> */}
        </div>
        <InputGroup className="pl-5 ">
          <Form.Control
             placeholder="Enter tag"
            aria-label="Enter Tag"
            value={itemTag}
            onChange={(e) => setItemTag(e.target.value)}
            
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleAddCartByTag();
              }
            }}

            style={{ paddingLeft: "50px" }}
          />
          { !itemTag && (itemTag || '' ).trim()?.length< 1 &&
          <span className="position-absolute text-muted " style={{ top:7, left:50, fontSize: isMDDevice ? '16px' :'13px' , pointerEvents:'none' }} > Enter Item Tag </span>
          }
        </InputGroup>
        {/* <Button className="tag-cart-btn" onClick={handleAddCartByTag} >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <circle cx="10.5" cy="19.5" r="1.5" fill="currentColor" />
            <circle cx="17.5" cy="19.5" r="1.5" fill="currentColor" />
            <path
              fill="currentColor"
              d="M21 7H7.334L6.18 4.23A1.995 1.995 0 0 0 4.333 3H2v2h2.334l4.743 11.385c.155.372.52.615.923.615h8c.417 0 .79-.259.937-.648l3-8A1.003 1.003 0 0 0 21 7m-4 6h-2v2h-2v-2h-2v-2h2V9h2v2h2z"
            />
          </svg>
        </Button> */}

        {animData && (
          <div >
            <Lottie
              lottieRef={lottieRef}
              onClick={handleAddCartByTag}
              animationData={animData}
              loop={true}
              autoplay={false}
              className="tag-cart-btn"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductTags;
